import APIClient from '@/shared/http/clients/api'

const resourceName = 'REComissao'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}?limit=${limit}&index=${index}`, data, config)
const GetAllByCredenciada = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllByCredenciada?limit=${limit}&index=${index}`, data, config)
const DeleteComissao = (id, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const GetComissaoByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro?limit=${limit}&index=${index}`, data, config)
const GetTotalComissoes = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/total/comissoes`, data, config)
const GetAllSearch = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search`, data, config)
const GetComissaoByFiltroAdm = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtroadm`, data, config)
const GetInfoTabelaPeloFiltroAdm = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/infotabelapelofiltro?limit=${limit}&index=${index}`, data, config)
const GetIdsAndFilter = (data, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/filtroadmByClick`, data, config)
const GetInfoTabelaPeloFiltroAdmById = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/filtroadmByClick/${id}`, data, config)
const GetAllCorretorsFilter = (ContaId, limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllByCorretorByCredenciada/${ContaId}?limit=${limit}&index=${index}`, data, config)
const GetCorretorByName = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getCorretorByName/${nome}`, data, config)
const GetEmpreendimentoByName = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoByName/${nome}`, data, config)
const GetFormOfPayment = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetFormOfPayment`, data, config)

const CommissionRepository = {
  GetAll,
  GetTotalComissoes,
  DeleteComissao,
  GetComissaoByFiltro,
  GetAllSearch,
  GetComissaoByFiltroAdm,
  GetInfoTabelaPeloFiltroAdm,
  GetIdsAndFilter,
  GetInfoTabelaPeloFiltroAdmById,
  GetAllByCredenciada,
  GetAllCorretorsFilter,
  GetCorretorByName,
  GetEmpreendimentoByName,
  GetFormOfPayment
}
export default CommissionRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/commission.js